



























































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeInput from "../general/CategoryTypeInput.vue";

import RentalItemJson from "../../shared/RentalItemJson";
import ItemDescriptionJson from "../../shared/ItemDescriptionJson";
import RentalConditionJson from "../../shared/RentalConditionJson";
import SettingsJson from "../../shared/SettingsJson";
import PriceUtils from "../../shared/PriceUtils";
import { CategoryTypeType } from "../../shared/CategoryTypeType";

import { WeekDay, AllWeekDays, WeekDayNames } from "../../shared/WeekDay";
import { Month, AllMonths, MonthNames } from "../../shared/Month";
import PriceTemplateManualJson, { PriceTemplateManual } from "../../shared/PriceTemplateManualJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateRentalConditionJson, validateUniqueRentalConditionTitle } from "../../shared/RentalConditionJson";

import PriceTemplates from "../custom/PriceTemplates";

type keysForCachedPrices = {
  [key in keyof Pick<RentalConditionJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "RentalProductDetailsCondition",
  components: {
    PointerMenu,
    Loading,
    CategoryTypeInput,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    type: String,
    data: Object as PropType<RentalConditionJson>,
    allConditions: Array as PropType<RentalConditionJson[]>,
    editable: Boolean,
    index: Number,
    submitValidation: Boolean,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      AllWeekDays: AllWeekDays,
      WeekDayNames: WeekDayNames,
      AllMonths: AllMonths,
      MonthNames: MonthNames,
      PriceUtils: PriceUtils,
      CategoryTypeType: CategoryTypeType,
      PriceTemplates: PriceTemplates as PriceTemplateManual,
      UserPermissionRank: UserPermissionRank,
      conditionDetails: null as RentalConditionJson | null,
      cachedPrices: {} as keysForCachedPrices,
      selectedRentalConditionTemplate: null as number | null,
      isNewCondition: true as boolean,
      toValidate: {} as any,
      validation: null as ValidationResult<RentalConditionJson> | null,
      frontendValidations: {
        title: false,
      },
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      //this.loadSettings();
      this.conditionDetails = this.data;
      this.setCachedData();
      this.setIsNewCondition();
    },

    /* async loadSettings() {
      if (this.restClient != null) {
        this.settings = null;

        try {
          this.settings = await this.restClient.getSettings();
        } catch (e) {
          alert(e.message);
        }
      }
    }, */

    setCachedData() {
      this.setCachedPrices();

      /* this.$nextTick(() => {
        this.hasChanges = false;
      }); */
    },

    //START set cached data

    setCachedPrices() {
      if (this.conditionDetails != null) {
        this.cachedPrices = {
          price: this.getFormatPrice(this.conditionDetails.price),
          cancellationFee: this.getFormatPrice(this.conditionDetails.cancellationFee),
        };
      }
    },

    //END set cached data

    setIsNewCondition() {
      if (this.conditionDetails != null) {
        if (this.conditionDetails.title != "") {
          this.isNewCondition = false;
        }
      }
    },

    setRentalConditionTemplate() {
      if (this.conditionDetails != null) {
        if (this.selectedRentalConditionTemplate != null && this.type && this.PriceTemplates.hasOwnProperty("rental")) {
          const templates = this.PriceTemplates.rental[this.type] as PriceTemplateManualJson[];

          this.conditionDetails.title = templates[this.selectedRentalConditionTemplate].title;
          this.conditionDetails.remarks = templates[this.selectedRentalConditionTemplate].remarks;
          this.conditionDetails.cancellationRemarks =
            templates[this.selectedRentalConditionTemplate].cancellationRemarks;

          if (templates[this.selectedRentalConditionTemplate].cancellationFee !== undefined) {
            this.conditionDetails.cancellationFee = templates[this.selectedRentalConditionTemplate].cancellationFee!;
          }

          if (templates[this.selectedRentalConditionTemplate].priceIncludedVATRate !== undefined) {
            this.conditionDetails.priceIncludedVATRate =
              templates[this.selectedRentalConditionTemplate].priceIncludedVATRate!;
          }

          if (templates[this.selectedRentalConditionTemplate].rentalDurationStartWeekDay !== undefined) {
            this.conditionDetails.rentalDurationStartWeekDay =
              templates[this.selectedRentalConditionTemplate].rentalDurationStartWeekDay!;
          }

          if (templates[this.selectedRentalConditionTemplate].rentalDurationDays !== undefined) {
            this.conditionDetails.rentalDurationDays =
              templates[this.selectedRentalConditionTemplate].rentalDurationDays!;
          }
        } else {
          this.conditionDetails.title = "";
          this.conditionDetails.remarks = "";
          this.conditionDetails.cancellationFee = 0;
          this.conditionDetails.cancellationRemarks = "";
          this.conditionDetails.priceIncludedVATRate = 0;
          this.conditionDetails.rentalDurationStartWeekDay = null;
          this.conditionDetails.rentalDurationDays = 1;
        }

        this.setCachedPrices();

        this.validateUniqueTitle();
        this.inputValidation("title");

        this.validation = validateRentalConditionJson(this.conditionDetails);
      }
    },

    inputValidation(key: any, prop: any = undefined) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.conditionDetails != null) {
        this.validation = validateRentalConditionJson(this.conditionDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START frontend Validation

    validateUniqueTitle() {
      if (this.conditionDetails != null) {
        this.frontendValidations.title = validateUniqueRentalConditionTitle(
          this.conditionDetails.title,
          this.allConditions
        );
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    //END frontend validation

    //START set input data (where data be cached)

    formatAndSetCachedPrice(key: keyof keysForCachedPrices) {
      if (this.conditionDetails != null) {
        let price = this.cachedPrices[key].replace(".", ",");

        if (!price.includes(",")) {
          price += ",00";
        }

        if (!price.match(/^\d{1,}(,\d{2})?$/)) {
          price = "";
        }

        this.cachedPrices[key] = price;
        this.conditionDetails[key] = parseInt(price.replace(/[\D]/g, ""));
      }
    },

    //END set input data (where data be cached)

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    submitValidation: function () {
      if (this.submitValidation) {
        if (this.conditionDetails != null) {
          this.validation = validateRentalConditionJson(this.conditionDetails);
        }
      }
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    /* restrictToTypes: {
      get(): string[] | undefined {
        if (this.conditionDetails != null) {
          if (this.conditionDetails.restrictToTypes == null) {
            return [];
          } else {
            return this.conditionDetails.restrictToTypes;
          }
        }
      },
      set(value: string[]) {
        if (this.conditionDetails != null) {
          if (value.length <= 0) {
            this.conditionDetails.restrictToTypes = null;
          } else {
            this.conditionDetails.restrictToTypes = value;
          }
        }
      },
    }, */

    /* selectedDeletedRentalAccountTypes() {
      let filteredRestrictToTypes: string[] = [];

      if (this.conditionDetails?.restrictToTypes != null) {
        filteredRestrictToTypes = this.conditionDetails.restrictToTypes;
        filteredRestrictToTypes = filteredRestrictToTypes.filter((i: string) => {
          if (this.settings != null) {
            if (!this.settings.rentalAccountTypes.includes(i)) {
              return i;
            }
          }
        });
      }

      return filteredRestrictToTypes;
    }, */

    parseRestrictMaxRentalDurationDays: {
      get(): number | null | undefined {
        if (this.conditionDetails != null) {
          return this.conditionDetails.restrictMaxRentalDurationDays;
        }
      },
      set(value: string) {
        if (this.conditionDetails != null) {
          if (value == "") {
            this.conditionDetails.restrictMaxRentalDurationDays = null;
          } else {
            this.conditionDetails.restrictMaxRentalDurationDays = parseInt(value);
          }
        }
      },
    },
  },
});
